import { render, staticRenderFns } from "./StockPerBuyerPerPerson.vue?vue&type=template&id=0fa5d646&"
import script from "./StockPerBuyerPerPerson.vue?vue&type=script&lang=js&"
export * from "./StockPerBuyerPerPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports